import { render, staticRenderFns } from "./BarcodeSettings.vue?vue&type=template&id=3c31d60e"
import script from "./BarcodeSettings.vue?vue&type=script&lang=ts"
export * from "./BarcodeSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c31d60e')) {
      api.createRecord('3c31d60e', component.options)
    } else {
      api.reload('3c31d60e', component.options)
    }
    module.hot.accept("./BarcodeSettings.vue?vue&type=template&id=3c31d60e", function () {
      api.rerender('3c31d60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/BarcodeSettings.vue"
export default component.exports